<template>
<div style="background-color:#e4e4e4" class="pa-1">
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="filteredGridRows"
    :search="search"
    class="elevation-1"
    dense
    fixed-header
    height="60vh"
    :items-per-page="100"
    :footer-props="footerProps"
    :loading="loadTable"
    loading-text="Ачааллаж байна... Түр хүлээнэ үү!"
    no-data-text="Мэдээлэл байхгүй байна."
    no-results-text="Тохирох үр дүн олдсонгүй. Та дахин хайна уу?"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>МӨНГӨН ГҮЙЛГЭЭНИЙ ТАЙЛАН</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-col>
          <tr>
            <td>{{org_nm}}</td>
          </tr>
          <tr>
            <td><small>(Аж ахуйн нэгжийн нэр)</small></td>
          </tr>
        </v-col>
        <v-col cols="12" sm="3">
          <tr>
            <td><small>Тайлант үе : {{dateRangeText}}</small></td>
          </tr>
          <tr>
            <td align="right"><small>/төгрөгөөр/</small></td>
          </tr>
        </v-col>

        <!-- Print (start) -->
        <v-btn
          color="blue lighten-3"
          dark
          class="mb-2 mr-2"
          @click="wholePrint()"
        >
          PDF <i class="mdi mdi-printer" aria-hidden="true"></i>
        </v-btn>
        <!-- Print (end) -->

        <!-- Export (start) -->
        <vue-json-csv
          class="btn btn-default"
          :data="filteredGridRows2"
          :fields="export_fields"
          :labels="export_labels"
          name="report_money.csv"
        >
          <v-btn color="error lighten-2" dark class="mb-2 mr-2">
            Export <i class="mdi mdi-export-variant" aria-hidden="true"></i>
          </v-btn>
        </vue-json-csv>
        <!-- Export (end) -->

      </v-toolbar>
    </template>

    <template v-slot:item.amnt1="{ item }">
      <span>{{formatPrice(item.amnt1)}}</span>
    </template>
    <template v-slot:item.amnt2="{ item }">
      <span>{{formatPrice(checkAmnt(item, 2))}}</span>
    </template>

    <template v-slot:no-data>
    </template>
  </v-data-table>
</div>
</template>

<script>
  import axios from 'axios';
  import jsPDF from 'jspdf';
  import {_ARIAL, _ARIAL_BOLD, _ARIAL_ITALIC, _ARIAL_BOLD_ITALIC} from '/src/assets/constant/constant.js'
  import common from '/src/assets/common/common.js'

  let bgColorCode = "orange lighten-5";
  export default {
    data: () => ({
      footerProps: {'items-per-page-options': [10, 20, 50, 100, -1]},
      search: '',
      selected: [],
      orgs: [],
      loadTable: true,
      org_nm: '',
      date_range: ['', ''],
      headers: [
        { text: 'Мөрийн дугаар', value: 'notes', divider: true, sortable: false, class: bgColorCode, width: '120px' },
        { text: 'Үзүүлэлт', value: 'name', divider: true, sortable: false, class: bgColorCode },
        { text: 'Эхний үлдэгдэл', value: 'amnt1', divider: true, sortable: false, align: 'right', class: bgColorCode },
        { text: 'Тайлант үеийн үлдэгдэл', value: 'amnt2', divider: true, sortable: false, align: 'right', class: bgColorCode },
      ],
      export_fields: [
        'notes', 'name', 'amnt1', 'amnt2'
      ],
      export_labels: {
        notes: 'Мөрийн дугаар',
        name: 'Үзүүлэлт',
        amnt1: 'Эхний үлдэгдэл',
        amnt2: 'Тайлант үеийн үлдэгдэл'
      },
      filters: {
        notes: [],
				name: [],
			},
      gridRows: [],
    }),

    computed: {
      filteredGridRows() {
				return this.gridRows.filter((d) => {
					return Object.keys(this.filters).every((f) => {
						return d.code != 202000 && (this.filters[f].length < 1 || this.filters[f].includes(d[f]));
					});
				});
			},
      filteredGridRows2() {
        return this.filteredGridRows.map(obj => {
              let rObj = {"code":obj.code,"notes":obj.notes,"name":obj.name,"da_amnt":obj.da_amnt,"ca_amnt":obj.ca_amnt,
                          "dc_amnt":obj.dc_amnt,"cc_amnt":obj.cc_amnt,"dl_amnt":obj.dl_amnt,"cl_amnt":obj.cl_amnt,
                          "amnt1":obj.amnt1,"amnt2":this.checkAmnt(obj, 2)}
              return rObj
        });
			},
      dateRangeText () {
        return this.date_range.join(' ~ ')
      },
    },

    watch: {
    },

    created () {
      this.initialize()
      this.getOrgInfo()
    },

    methods: {
      initialize () {
        this.org_nm = JSON.parse(sessionStorage.getItem('user_org')).name
        this.date_range = JSON.parse(sessionStorage.getItem('user_dt')).dt
        let user_org = JSON.parse(sessionStorage.getItem('user_org'))
        let user_dt = JSON.parse(sessionStorage.getItem('user_dt')).dt
        let parent_code = '202'
        let rprt_code = '301004'
        const params = {
          org_id: { toJSON: () => user_org.id },
          s_dt: user_dt[0],
          f_dt: user_dt[1],
          p_cd: parent_code,
          r_cd: rprt_code
        };
        axios.get('commoncode/accts_rprt_code', { params })
          .then(response => {
            this.gridRows = response.data;
            this.loadTable = false;
            // console.log(JSON.stringify(this.acctsGridRows));
          })
          .catch(error => {
            console.log(error)
          });
      },

      getOrgInfo () {
        let userId = JSON.parse(sessionStorage.getItem('user')).id
        axios.get('org/by_user/' + userId)
          .then(response => {
            this.orgs = response.data;
          })
          .catch(error => {
            console.log(error)
          }
        )
      },

      formatPrice(value) {
        return value == null || value == "0" ? "-" : Number(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      totalBalance(item, type) {
        return type == 1 ? (Number(item.debit_amnt)+Number(item.credit_amnt)) : 0
      },

      checkAmnt(item, type) {
        // if (type == 1) {
        //   return item.code == '202051' ? this.gridRows.find(f => Number(f.code) == 202000).amnt1 : 0;
        // }
        if (item.code == '202030') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202022).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['amnt2']) || 0), 0);
          // return Number(item.amnt2) + this.gridRows.filter(f => Number(f.code) == 202022).reduce((a, b) => Number(a) + (Number(b['amnt2']) || 0), 0);
        } else if (item.code == '202031') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202023).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        } else if (item.code == '202032') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202024).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        } else if (item.code == '202033') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202025).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        } else if (item.code == '202034') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202026).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        } else if (item.code == '202043') {
          return Number(item.amnt2) + this.gridRows.find(f => Number(f.code) == 202039).dc_amnt; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        } else if (item.code == '202050') {
          return this.gridRows.find(f => Number(f.code) == 202051).amnt1; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        // } else if (item.code == '202051') {
        //   return this.gridRows.find(f => Number(f.code) == 202000).amnt2; //reduce((a, b) => Number(a) + (Number(b['cc_amnt']) || 0), 0);
        }
        else if (item.code == '202002') {
          return this.gridRows.filter(f => Number(f.code) >= 202003 && Number(f.code) <= 202008).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202009') {
          return this.gridRows.filter(f => Number(f.code) >= 202010 && Number(f.code) <= 202018).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        // } else if (item.code == '202012') {
        //   return this.gridRows.filter(f => Number(f.code) >= 202010 && Number(f.code) <= 202018).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202019') {
          return this.gridRows.filter(f => Number(f.code) >= 202003 && Number(f.code) <= 202008).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202010 && Number(f.code) <= 202018).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202021') {
          return this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202028).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202029') {
          return this.gridRows.filter(f => Number(f.code) >= 202030 && Number(f.code) <= 202034).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            + this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202026).reduce((a, b) => Number(a) + (Number(b['dc_amnt']) || 0), 0);
        } else if (item.code == '202036') {
          return this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202028).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202030 && Number(f.code) <= 202034).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202026).reduce((a, b) => Number(a) + (Number(b['dc_amnt']) || 0), 0);
        } else if (item.code == '202038') {
          return this.gridRows.filter(f => Number(f.code) >= 202039 && Number(f.code) <= 202041).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202042') {
          return this.gridRows.filter(f => Number(f.code) >= 202044 && Number(f.code) <= 202046).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            + this.gridRows.find(f => Number(f.code) == 202039).dc_amnt;
        } else if (item.code == '202047') {
          return this.gridRows.filter(f => Number(f.code) >= 202039 && Number(f.code) <= 202041).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202043 && Number(f.code) <= 202046).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.find(f => Number(f.code) == 202039).dc_amnt;
        } else if (item.code == '202049') {
          return (this.gridRows.filter(f => Number(f.code) >= 202003 && Number(f.code) <= 202008).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202010 && Number(f.code) <= 202018).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0))
            + (this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202028).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
              - this.gridRows.filter(f => Number(f.code) >= 202030 && Number(f.code) <= 202034).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
              - this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202026).reduce((a, b) => Number(a) + (Number(b['dc_amnt']) || 0), 0))
            + (this.gridRows.filter(f => Number(f.code) >= 202039 && Number(f.code) <= 202041).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - (this.gridRows.filter(f => Number(f.code) >= 202044 && Number(f.code) <= 202046).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
                + this.gridRows.find(f => Number(f.code) == 202039).dc_amnt))
            + this.gridRows.filter(f => Number(f.code) == 202048).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0);
        } else if (item.code == '202051') {
          // 2023.01.11 (49+50 baih estoi gd oochlov!)
          return (this.gridRows.filter(f => Number(f.code) >= 202003 && Number(f.code) <= 202008).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - this.gridRows.filter(f => Number(f.code) >= 202010 && Number(f.code) <= 202018).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0))
            + (this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202028).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
              - this.gridRows.filter(f => Number(f.code) >= 202030 && Number(f.code) <= 202034).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
              - this.gridRows.filter(f => Number(f.code) >= 202022 && Number(f.code) <= 202026).reduce((a, b) => Number(a) + (Number(b['dc_amnt']) || 0), 0))
            + (this.gridRows.filter(f => Number(f.code) >= 202039 && Number(f.code) <= 202041).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            - (this.gridRows.filter(f => Number(f.code) >= 202044 && Number(f.code) <= 202046).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
                + this.gridRows.find(f => Number(f.code) == 202039).dc_amnt))
            + this.gridRows.filter(f => Number(f.code) == 202048).reduce((a, b) => Number(a) + (Number(b[type == 1 ? 'amnt1' : 'amnt2']) || 0), 0)
            + item.amnt1;
        } else {
          return Number(item.amnt2);
        }
      },

      columnValueList(val) {
				return this.gridRows.map((d) => d[val]);
			},

      sumField(key) {
        // sum data in give key (property)
        return this.filteredGridRows.reduce((a, b) => Number(a) + (Number(b[key]) || 0), 0)
      },

      wholePrint() {
        if (this.filteredGridRows2.length == 0) { return alert('Мэдээлэл байхгүй байна.'); }
        // include autotable library
        require('jspdf-autotable');
        var org_nm = JSON.parse(sessionStorage.getItem('user_org')).name
        var org_id = JSON.parse(sessionStorage.getItem('user_org')).id
        var org = this.orgs.filter(x=> x.id==org_id)[0]
        var date_range = JSON.parse(sessionStorage.getItem('user_dt')).dt

        // create jspdf constant
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: "a4"
        });

        // Add mongolian font (Arial-Mon)
        doc.addFileToVFS('Arial-Mon-normal.ttf', _ARIAL);
        doc.addFileToVFS('Arial-Mon-bold.ttf', _ARIAL_BOLD);
        doc.addFileToVFS('Arial-Mon-italic.ttf', _ARIAL_ITALIC);
        doc.addFont('Arial-Mon-normal.ttf', 'Arial-Mon', 'normal');
        doc.addFont('Arial-Mon-bold.ttf', 'Arial-Mon', 'bold');
        doc.addFont('Arial-Mon-italic.ttf', 'Arial-Mon', 'italic');

        // set report title on top
        doc.setFont("Arial-Mon", "bold").setFontSize(12).text('МӨНГӨН ГҮЙЛГЭЭНИЙ ТАЙЛАН', 140, 30);
        // text is placed using x, y coordinates (landscape)
        doc.setFont("Arial-Mon", "normal").setFontSize(10).text(org_nm, 20, 60);
        doc.setFont("Arial-Mon", "normal").setFontSize(10).text(date_range.join(' ~ '), 340, 60);
        doc.setFont("Arial-Mon", "normal").setFontSize(8).text('( Аж ахуйн нэгжийн нэр )', 20, 67);
        doc.setFont("Arial-Mon", "normal").setFontSize(8).text('/ төгрөгөөр /', 340, 67);
        
        // set headers and data for autoTable
        const headers2 = [
          ['Мөрийн дугаар', 'Үзүүлэлт', 'Эхний үлдэгдэл', 'Тайлант үеийн үлдэгдэл']
        ];
        let data2 = [];
        this.filteredGridRows2.forEach(function (e) {
          var ids = [];
          ids.push(e.notes);
          ids.push(e.name);
          ids.push(common.moneyFormat(e.amnt1));
          ids.push(common.moneyFormat(e.amnt2));
          data2.push(ids);
        });

        if (data2.length == 0) { data2.push(['Мэдээлэл байхгүй байна.']) }

        // Using autoTable plugin
        doc.autoTable({ head: headers2, headStyles: { fillColor: 'white', lineWidth: 0.1, lineColor: 'gray', halign: 'center', textColor: 'black'},
                        body: data2, tableLineWidth: 0.75, theme: "grid",
                        columnStyles: { 2: { halign: 'right' }, 3: { halign: 'right' } },
                        margin: { left: 20, top: 70, right: 20 }, styles : { font : 'Arial-Mon', fontStyle :'normal', fontSize : 9} })
        let finalY = doc.lastAutoTable.finalY;
        doc.setFont("Arial-Mon", "normal").setFontSize(9).text('Захирал: ............................. / ' + org.ceo_firstname + ' /', 160, finalY+30);
        doc.setFont("Arial-Mon", "normal").setFontSize(9).text('Нягтлан бодогч: .................. / ' + org.acct_firstname + ' /', 160, finalY+45);
        
        // saving file
        doc.save(`report_money.pdf`);
      },

    },
  }
</script>